import { roundDecimals as m } from "@project-rouge/rg-core";
import { Vector3 as p } from "three";
import { isPolygonClockwise as y } from "../../geometry-utils/is-polygon-clockwise/index.js";
import { unionPolygons as A } from "../../geometry-utils/clipper-utils/index8.js";
import { offsetPolygon as n } from "../../geometry-utils/clipper-utils/index5.js";
function L(t, a, e, s) {
  const f = Array.isArray(t[0][0]);
  t = t.map((r) => r.map((o) => Array.isArray(o) ? o : o.toArray())), t = t.map((r) => y(r) ? r : r.reverse());
  const c = t.map((r) => n(r, a).map((o) => [m(o[0]), e, m(o[2])])), i = [], u = A(c);
  for (const r of u) {
    const o = n(r, -a);
    if (i.push(o), s)
      break;
  }
  return f ? i : i.map((r) => r.map((o) => new p(...o)));
}
export {
  L as getBoundaries
};
//# sourceMappingURL=index3.js.map
